import { Box, Button, Flex, FormControl, FormLabel, Grid, GridItem, Image, Input, Select, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, IconButton, InputGroup, InputLeftElement, Divider, } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import MyDiv from "./codeOfConduct.style";
import { CustomTable, CustomToast } from "../../../../components";
import { Column } from "../../../../components/CustomTable/customTable";
import { IBranchDropdown, ICompanyDropdown } from "./model";
import { useFetch } from "../../../../hooks/useFetch";
import { EditIcon } from "@chakra-ui/icons";

interface ICodeOfConduct {
  id: number;
  company: string;
  branch: string;
  file_Path: string;
  fileType: string;
  file: File;
}


const CodeOfConduct = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const fileRef = useRef<HTMLInputElement | null>(null);
  const [tableData, setTableData] = useState<ICodeOfConduct[]>([]);
  const [formData, setFormData] = useState({ company: "", branch: "", file: null as File | null,});
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedDocName, setSelectedDocName] = useState("");
  const [companyDropdown, setCompanyDropdown] = useState<ICompanyDropdown[]>([]);
  const [branch, setBranch] = useState<IBranchDropdown[]>([]);
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
const [uploadedFileName, setUploadedFileName] = useState("");
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];

    if (!selectedFile) return;

    const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg",];

    if (!allowedTypes.includes(selectedFile.type)) {
      addToast({
        message: "Only PDF and Image files are allowed",
        status: "warning",
      });
      return;
    }

    setFormData((prev) => ({
      ...prev,
      file: selectedFile,
    }));
  };

 const handleAddNew = () => {
  setIsEditMode(false);

  setSelectedId(null);

  setUploadedFileName("");

  setFormData({
    company: "",
    branch: "",
    file: null,
  });

  if (fileRef.current) {
    fileRef.current.value = "";
  }

  onOpen();
};

  const handleSubmit = async () => {
    if (!formData.company) {
      addToast({ message: "Please select company", status: "warning", });
      return;
    }

    if (!formData.branch) {
      addToast({ message: "Please select branch", status: "warning", });
      return;
    }

if (!formData.file && !uploadedFileName) {
  addToast({
    message: "Please upload file",
    status: "warning",
  });

  return;
}

const selectedCompanyName = companyDropdown.find(
  (c) => String(c.company_ID) === formData.company
)?.company_Name;

const selectedBranchName = branch.find(
  (b) => String(b.branch_Id) === formData.branch
)?.branchName;

const isDuplicate = tableData.some(
  (item: any) =>
    item.company_Name === selectedCompanyName &&
    item.branch_Name === selectedBranchName &&
    (!isEditMode || item.id !== selectedId)
);

if (isDuplicate) {
  addToast({
    message: "Code Of Conduct already exists for this company and branch",
    status: "warning",
  });

  return;
}

// setLoading(true);
    const payload = new FormData();
    payload.append("companyId", formData.company);
    payload.append("branchId", formData.branch);

    if (formData.file) {
      payload.append("file", formData.file);
    }

    let response = null;

if (isEditMode && selectedId) {
  payload.append("id", String(selectedId));

  response = await fetchApi(  `Hrlense_CodeofConduct/UploadCodeOfConduct/${selectedId}`,  "PUT",  payload,  null,  "Code Of Conduct updated successfully",  true);
} else {
  response = await fetchApi( "Hrlense_CodeofConduct/UploadCodeOfConduct", "POST", payload, null, "Code Of Conduct added successfully", true);
}
 if (response) {
  await loadCodeOfConduct();

  setUploadedFileName("");

  setFormData({
    company: "",
    branch: "",
    file: null,
  });

  setIsEditMode(false);
  setSelectedId(null);

  if (fileRef.current) {
    fileRef.current.value = "";
  }
  onClose();
}
    // setLoading(false);
  };

  const loadCodeOfConduct = async () => {
    setLoading(true);
    const response = await fetchApi<ICodeOfConduct[]>("Hrlense_CodeofConduct/GetCodeOfConduct", "GET");

    if (response) {
      setTableData(response);
    }
    setLoading(false);
  };

  const loadCompanyDropdown = async () => {
    const response = await fetchApi<ICompanyDropdown[]>("Dropdown/company", "GET");

    if (response) {
      setCompanyDropdown(response);
    }
  };

  const branchData = async (companyID?: number) => {
    const response = await fetchApi<IBranchDropdown[]>("DropDown/branches", "GET", "", companyID ? `companyId=${companyID}` : null);

    if (response) {
      setBranch(response);
    }
  };

  useEffect(() => {
    loadCompanyDropdown();
    loadCodeOfConduct();
  }, []);

  const handleViewDocument = async (filePath: string) => {
    try {
      const response = await fetchApi( "Hrlense_CodeofConduct/GetCodeOfConductFile", "GET", null, `fileName=${filePath}`);

      if (response) {
        const { contentType, base64 } = response;
        const fileUrl = `data:${contentType};base64,${base64}`;
        setSelectedFile(fileUrl);
        setSelectedDocName(filePath);
        setPreviewOpen(true);
      }
    } catch (err) {
      console.error("Error fetching document:", err);

      addToast({ message: "Failed to load document", status: "error",});
    }
  };


  const handleInputChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "company") {
      setFormData((prev) => ({
        ...prev,
        company: value,
        branch: "",
      }));

      setBranch([]);

      branchData(Number(value));
    }
  };

  const handleEdit = async (rowData: any) => {
  setIsEditMode(true);

  setSelectedId(rowData.id);

  const selectedCompany = companyDropdown.find(
    (item) =>
      item.company_Name === rowData.company_Name
  );

  if (selectedCompany) {
    await branchData(selectedCompany.company_ID);

    const branchResponse =
      await fetchApi<IBranchDropdown[]>( "DropDown/branches", "GET", "", `companyId=${selectedCompany.company_ID}`);
    const selectedBranch = branchResponse?.find(
      (item) =>
        item.branchName === rowData.branch_Name
    );

    setFormData({
      company: String(selectedCompany.company_ID),
      branch: selectedBranch
        ? String(selectedBranch.branch_Id)
        : "",
      file: null,
    });
  }

  setUploadedFileName(rowData.file_Path);
  onOpen();
};
  return (
    <MyDiv>
      <Box>
        <Flex justify="space-between" align="center" mb={5}>
          <Text fontSize="24px" fontWeight="600">
            Code Of Conduct
          </Text>

          <Button bg="#006838" color="white" onClick={handleAddNew}>
            Add New
          </Button>
        </Flex>

        <Grid className="grid_container">
          <GridItem colSpan={12}>
            <CustomTable value={tableData} loading={loading} emptyMessage="No records found.">
              <Column header="S.No" body={(_, index) => index + 1} />
              <Column header="Company" field="company_Name" />
              <Column header="Branch" field="branch_Name" />
              <Column
                header="Document View"
                body={(rowData: ICodeOfConduct) => (
                  <Text  color="#006838"  cursor="pointer"  textDecoration="underline"  onClick={() => handleViewDocument(rowData.file_Path)}>
                    View
                  </Text>
                )}
              />
              <Column
                header="Action"
                body={(rowData: ICodeOfConduct) => (
                  <IconButton aria-label="Edit" icon={<EditIcon />} variant="ghost" size="sm" onClick={() => handleEdit(rowData)} />
                )}
              />
            </CustomTable>
          </GridItem>
        </Grid>

        <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader borderBottom="1px solid #E2E8F0">
              {isEditMode ? "Edit Code Of Conduct" : "Add Code Of Conduct"}
            </DrawerHeader>
            <DrawerBody>
              <FormControl mb={4}>
                <FormLabel>Company</FormLabel>
                <Select placeholder="Select Company" name="company" value={formData.company} onChange={handleInputChange}>
                  {companyDropdown.map((item) => (
                    <option key={item.company_ID} value={item.company_ID}>
                      {item.company_Name}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mb={4}>
                <FormLabel>Branch</FormLabel>
                <Select placeholder="Select Branch" name="branch" value={formData.branch} onChange={handleInputChange} isDisabled={!branch.length}>
                  {branch.map((item) => (
                    <option key={item.branch_Id} value={item.branch_Id}>
                      {item.branchName}
                    </option>
                  ))}
                </Select>
              </FormControl>

              <FormControl mb={4}>
                <FormLabel>Upload File</FormLabel>

                <Flex align="center">
                  <InputGroup>
                    <InputLeftElement width="auto" px={2}>
                      <Button as="label" htmlFor="codeofconduct-upload" size="sm" cursor="pointer" borderRadius="6px" className="font-poppins text_sm text_regular" >
                        Upload
                      </Button>
                      <input id="codeofconduct-upload" type="file" accept=".pdf,image/*" hidden onChange={handleFileChange} ref={fileRef} />
                    </InputLeftElement>
                    <Input className="font-poppins text_sm text_regular" placeholder="No file chosen" value={formData.file?.name || uploadedFileName} isReadOnly pl="120px" />
                  </InputGroup>
                </Flex>
              </FormControl>

              <Flex justify="flex-end" gap={3} mt={10}>
                <Button onClick={onClose} bg="#D92F34" color="white">
                  Cancel
                </Button>

                <Button bg="#006838" color="white" onClick={handleSubmit}>
                  {isEditMode ? "Update" : "Save"}
                </Button>
              </Flex>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </Box>



      <Modal isOpen={previewOpen} onClose={() => setPreviewOpen(false)} size="2xl" isCentered>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader
            alignSelf="center"
            className="font-poppins text_medium text_xl"
            color="rgba(102, 102, 102, 1)"
          >
            {selectedDocName}
          </ModalHeader>

          <ModalCloseButton />

          <Divider />

          <ModalBody  display="flex"  justifyContent="center"  alignItems="center">
            {selectedFile && (
              selectedFile.includes("application/pdf") ? (
                <iframe
                  src={selectedFile}
                  style={{
                    width: "100%",
                    height: "80vh",
                    border: "none",
                  }}
                  title="PDF Preview"
                />
              ) : (
                <Image src={selectedFile} alt={selectedDocName} maxH="80vh" objectFit="contain"/>
              )
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </MyDiv>
  );
};

export default CodeOfConduct;